export default "__VITE_ASSET__BGwWQRQO__"